import React, {ReactNode} from "react";
import {AnnotationProperties, SVG_NAMESPACE} from "../Annotation";
import FunctionHelper from "../../helper/FunctionHelper";
import PortalPureComponent from "../../components/PortalPureComponent";

export class StarIcon extends PortalPureComponent<AnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		return (
			<svg xmlns={SVG_NAMESPACE} width={this.props.width} height={this.props.height} viewBox="0 0 20 20"
				 style={{
					 opacity: FunctionHelper.applyValue(this.props.opacity, 1),
					 transform: "rotate(" + FunctionHelper.applyValue(this.props.rotation, 0) + "deg)",
				 }}>
				<path
					d="M10,1.3l2.388,6.722H18.8l-5.232,3.948l1.871,6.928L10,14.744l-5.438,4.154l1.87-6.928L1.199,8.022h6.412L10,1.3z"
					style={{
						fill: this.props.color,
						fillOpacity: 0.5,
						stroke: "#000000",
						strokeWidth: 1,
						strokeOpacity: 1
					}}/>
			</svg>
		);
	}
}